import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            let errorMessage = 'An error occurred';

            if (error.error instanceof ErrorEvent) {
                errorMessage = error.error.message;
            } else {
                errorMessage = error.error?.msg || error.message;
            }

            console.error('HTTP Error:', {
                status: error.status,
                message: errorMessage,
                url: req.url,
            });

            return throwError(() => ({
                status: error.status,
                msg: errorMessage,
            }));
        }),
    );
};
